/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsIconWithTextColumn = {
    init: function ($section) {
      this.$section = $section
      this.$sliderEl = $section.find('.slider-wrapper');
      this.$slides =  this.$sliderEl.find('[data-index]')

      this.$slider = this.$sliderEl.flickity({
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        watchCSS: true,
        cellAlign:'center'
      });

    },
    blockSelect: function ($section, blockId) {
      const $slider = $section.find('.slider-wrapper');
      const slideIndex = $('#shopify-section-' + blockId).data('index');
      $slider.flickity('select', slideIndex);
    },
    unload: function ($section) {
      const $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

  /******/
})()
  ;